// Centralized authentication utilities

import { postRequest } from '../Fetch/request';

// Helper function to refresh auth token
export const refreshAuthToken = async () => {
  try {
    const refreshToken = localStorage.getItem('refreshToken');
    
    if (!refreshToken || refreshToken === 'undefined' || refreshToken === 'null') {
      return false;
    }
    
    const data = await postRequest(`${process.env.REACT_APP_URL}/api/auth/refresh`, { refreshToken });
    
    if (data) {
      // Handle both possible response structures
      const newToken = data.token || data.data?.accessToken;
      const newRefreshToken = data.refreshToken || data.data?.refreshToken;
      
      if (newToken) {
        localStorage.setItem('authToken', newToken);
        if (newRefreshToken) {
          localStorage.setItem('refreshToken', newRefreshToken);
        }
        return true;
      }
    }
    return false;
      } catch (error) {
        return false;
    }
};

// Centralized logout function
export const logout = () => {
  // Clear all auth data
  localStorage.removeItem('email');
  localStorage.removeItem('userId');
  localStorage.removeItem('profileObject');
  localStorage.removeItem('authToken');
  localStorage.removeItem('refreshToken');
  
  // Reload in place so the user stays on the same page
  window.location.reload();
};

// Helper function to get auth token
export const getAuthToken = () => {
  return localStorage.getItem('authToken');
};

// Helper function to get refresh token
export const getRefreshToken = () => {
  return localStorage.getItem('refreshToken');
};

// Simplified authentication check - just check if JWT token exists
export const isUserAuthenticated = () => {
  const authToken = getAuthToken();
  return !!authToken;
};

// Centralized function to get userId with proper fallback
export const getUserId = () => {
  try {
    // Try to get from localStorage directly first
    const directUserId = localStorage.getItem('userId');
    if (directUserId && directUserId !== 'null' && directUserId !== 'undefined') {
      return directUserId;
    }

    // Try to get from profileObject
    const profileString = localStorage.getItem('profileObject');
    if (profileString && profileString !== 'null' && profileString !== 'undefined') {
      try {
        const profile = JSON.parse(profileString);
        if (profile?.id && profile.id !== 'null' && profile.id !== 'undefined') {
          return profile.id;
        }
      } catch (e) {
      }
    }

    // Fallback for non-authenticated users
    return 'slazysloth_user';
  } catch (error) {
    return 'slazysloth_user';
  }
}; 